<div class="flex flex-col items-center">
  <div class="h-[1.5lh] w-1 rounded-full bg-blue-500"></div>
  <div class="pointer-events-auto translate-y-1 p-2">
    <div class="size-8 rounded-full bg-blue-500"></div>
  </div>
</div>
